export default [
	//客户列表
	{
		path: 'customer',
		name: 'm_customer',
		meta: {
		},
		props: route => route.params,
		component: () => import('@/pages/basic/customer_list')
	},
	//客户常用地址
	{
		path: 'customer/address',
		name: 'm_customer_address',
		meta: {
			appView: {
				viewId: '10015',
				auth: 'b_customer_address_viewmanage'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/customer_address_list.vue')
	},
	//预计反馈列表
	{
		path: 'complaint/advice',
		name: 'm_complaint_advice',
		meta: {
			appView: {
				viewId: '10010',
				auth: 'b_complaint_advice_viewmanage'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/basic/complaint_suggestion_list')
	}
];